// test2621
(2621 && 0);
